import React, { memo } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { PRIMARY, SECONDARY } from '../styles/colors';

/*
  O material precisa ser preenchido com todas essas posicoes no array
  para evitar warnings e errors de elevation is not implemented
  https://github.com/mui-org/material-ui/issues/17398
*/
// const REMOVE_SHADOWS = new Array(25).fill('none');

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: SECONDARY,
    },
    secondary: {
      main: PRIMARY,
    },
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 16,
  },
  input: {
    fontSize: 14,
  },
  root: {
    fontSize: 14,
  },
  overrides: {
    MuiButton: {
      contained: {
        borderRadius: 50,
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 600,
        '&$disabled': {
          'backgroundColor': '#ccc',
          color: '#fff'
        },
      },
      outlined: {
        borderRadius: 50,
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 600,
        borderColor: SECONDARY,
      },
      root: {
        '&$disabled': {
          'backgroundColor': '#ccc',
          color: '#fff'
        }
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: '14px',
        fontWeight: 500
      }
    },
    MuiInputBase: {
      input: {
        fontSize: '14px',
        fontWeight: 500
      }
    },
  },
});

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>
    {children}
  </ThemeProvider>
);

export default memo(Theme);